import { render, staticRenderFns } from "./order-return-contact-info.vue?vue&type=template&id=5b4b1c47&"
import script from "./order-return-contact-info.vue?vue&type=script&lang=js&"
export * from "./order-return-contact-info.vue?vue&type=script&lang=js&"
import style0 from "./order-return-contact-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports